import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import './styles.css';
import { inject } from '@vercel/analytics';

const root = createRoot(document.getElementById('root'));

inject();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
